// 封装缓存模块
export const addSessionItem = (key, value) => sessionStorage.setItem(key, value)

export const getSessionItem = (key) => sessionStorage.getItem(key)

export const removeSessionItem = (key) => sessionStorage.removeItem(key)

export const clearSessionItem = () => sessionStorage.clear()